import { Box } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import Header from '../components/Header';
import { useTranslation } from '../hooks/useTranslation';
import { DataContext } from '../contexts/DataContext';

function TermsPage() {
  const { i18n } = useTranslation();
  const { trackEvent } = useContext(DataContext);
  const [htmlContent, setHtmlContent] = useState('');
  useEffect(() => {
    trackEvent({ nav_to_terms: 1 });
  }, [trackEvent]);

  useEffect(() => {
    try {
      // Fetch the HTML file from the public folder
      fetch(
        '/iqos LU - Terms and Conditions ' +
          i18n.language.toUpperCase() +
          '.html'
      ).then((response) => {
        response.text().then((text) => setHtmlContent(text));
      });
    } catch (error) {
      console.error('Error loading HTML file:', error);
    }
  }, [i18n.language]);

  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
      }}
    >
      <Header />
      <Box
        sx={{
          flex: 1,
          height: 'calc( 96vh  )',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'stretch',
          paddingBottom: '30px',
          paddingTop: '16px',
          paddingInline: '16px',
          gap: '15px',
        }}
        className={'terms'}
      >
        {htmlContent && (
          <div
            dangerouslySetInnerHTML={{ __html: htmlContent }}
            style={{ textAlign: 'left' }}
          />
        )}
      </Box>
    </Box>
  );
}

export default TermsPage;
